import { useContext } from "react";
import { CommentsContext } from "../context";

export const useComments = () => useContext(CommentsContext);
